import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Tooltip from 'app/components/Tooltip';
import OpponentAvatar from 'app/components/OpponentAvatar';

import style from './style.scss';

interface Props {
  opponent: PandapiTeam | PandapiPlayer;
}

const GameAdvantageIndicator: FC<Props> = ({ opponent }) => {
  const [t] = useTranslation();

  return (
    <Tooltip className={style.container} content={t('events-match_game_avdantage')}>
      <OpponentAvatar size={15} opponent={opponent} />
      <span>{t('events-match_game_avdantage_acronym')}</span>
    </Tooltip>
  );
};

GameAdvantageIndicator.displayName = 'GameAdvantageIndicator';

export default GameAdvantageIndicator;
